import Subtitle from 'components/TextComps/Subtitle';
import { useTranslation } from 'react-i18next';
import { isPastDate } from 'utilities/isPastDate';
import { EventTile } from '../EventTile/EventTile';
import { NoUpcomingEvents } from '../NoUpcomingEvents/NoUpcomingEvents';
import { EventTileSkeleton } from '../EventTileSkeleton/EventTileSkeleton';
import { useMemo } from 'react';
import { useIsUserMember } from 'queryHooks/permissions';
import { useGetTrackmanEventsList } from 'queryHooks/trackmanEvents';

export const UpcomingEventsNew = () => {
  const { t } = useTranslation();

  const trackmanEventsList = useGetTrackmanEventsList();
  const isUserMember = useIsUserMember();

  const upcomingEvents = useMemo(() => trackmanEventsList.data?.events.filter((event) => !isPastDate(event.startDate)) || [], [trackmanEventsList.data]);

  return (
    <div className='events-subpage'>
      <div className='page-heading'>
        <Subtitle>
          <>{t('UpcomingEvents', { ns: 'trackmanEvents' })}</>
        </Subtitle>
      </div>
      {trackmanEventsList.isPending && isUserMember.isPending ? (
        Array.from(Array(10)).map((el, index) => <EventTileSkeleton key={index} />)
      ) : upcomingEvents.length ? (
        <div className='events-list'>
          {upcomingEvents.map((event, i) => (
            <EventTile key={`${event.title}+${i}`} eventItem={event} isUserMember={isUserMember.data} />
          ))}
        </div>
      ) : (
        <NoUpcomingEvents />
      )}
    </div>
  );
};
